import * as z from 'zod';

export const sendResetPasswordLinkSchema = z.object({
  email: z.string().min(1, { message: 'This field is required.' }).email('Invalid email'),
});

export type SendResetPasswordLinkRequest = z.infer<typeof sendResetPasswordLinkSchema>;
